export const T05_US_CLOUD_GRADIENT =
  'linear-gradient(137deg, #58595b 0%, #414042 50%, #6d6e71 100%)';

export const T05_EDGE_GRADIENT =
  'linear-gradient(137deg, #405bff 0%, #7084ff 45%, #34d399 100%)';

export const T05_CTA_GRADIENT =
  'linear-gradient(137deg, #405bff 0%, #7084ff 45%, #3dd6f5 100%)';

export const T05_STEP_GRADIENTS = [
  'linear-gradient(137deg, #405bff 0%, #7084ff 50%, #3dd6f5 100%)',
  'linear-gradient(137deg, #3dd6f5 0%, #7084ff 50%, #405bff 100%)',
  'linear-gradient(137deg, #34d399 0%, #3dd6f5 50%, #405bff 100%)',
] as const;

export const T05_STAT_GRADIENTS = [
  'linear-gradient(137deg, #405bff 0%, #7084ff 45%, #3dd6f5 100%)',
  'linear-gradient(137deg, #3dd6f5 0%, #7084ff 45%, #405bff 100%)',
  'linear-gradient(137deg, #34d399 0%, #3dd6f5 45%, #405bff 100%)',
  'linear-gradient(137deg, #405bff 0%, #34d399 45%, #3dd6f5 100%)',
] as const;
